interface IHaveName {
  name: string;
}

export class NamesFilterValueConverter {
  toView(items: IHaveName[], filter: string) {
    return filter ? items.filter(x => x.name.toUpperCase().includes(filter.toUpperCase())) : items;
  }
}
